export function generateDarkColor() {
  const getDarkValue = () =>
    Math.floor(Math.random() * 220)
      .toString(16)
      .padStart(2, '0');

  const r = getDarkValue();
  const g = getDarkValue();
  const b = getDarkValue();

  return `#${r}${g}${b}`;
}

export function generateDarkColorWithName(name: string) {
  let hash = 0;

  for (let i = 0; i < name.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  const minBrightness = 70;
  const maxBrightness = 160;

  const normalize = (value: number) => Math.floor((value % (maxBrightness - minBrightness)) + minBrightness);

  // eslint-disable-next-line no-bitwise
  const r = normalize((hash >> 0) & 0xff);
  // eslint-disable-next-line no-bitwise
  const g = normalize((hash >> 8) & 0xff);
  // eslint-disable-next-line no-bitwise
  const b = normalize((hash >> 16) & 0xff);

  const toHex = (value: number) => value.toString(16).padStart(2, '0');

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
